import { z } from "zod"
import { MembershipRoleEnum, MembershipStatusEnum } from "../../types/memberships"

export type MembershipResponse = z.infer<typeof MembershipResponseSchema>
export type MembershipItemPermissions = z.infer<typeof MembershipItemPermissionsSchema>
export type InvitationStatus = z.infer<typeof InvitationStatusSchema>
export type HourReporterMembershipResponse = z.infer<typeof HourReporterMembershipResponseSchema>
export type HourReporterMemberSummary = z.infer<typeof HourReporterMemberSummarySchema>
export type HourReportAuditableMembershipResponse = z.infer<typeof HourReportAuditableMembershipResponseSchema>
export type HourReportRoleAssignmentOption = z.infer<typeof HourReportRoleAssignmentOptionSchema>
export type HourReportAdmin = z.infer<typeof HourReportAdminSchema>
export type HourReportAdminsResponse = z.infer<typeof HourReportAdminsResponseSchema>
export type HourReportAdminAssignmentOption = z.infer<typeof HourReportAdminAssignmentOptionSchema>

export const InvitationStatusSchema = z.enum(["pending", "accepted", "rejected", "not_invited"])

export const MembershipItemPermissionsSchema = z.object({
  canReadDetails: z.boolean(),
  canReadPermissions: z.boolean(),
  canUpdatePermissions: z.boolean(),
  canUpdateDetails: z.boolean(),
  canUpdateInvitationStatus: z.boolean(),
})

export const MembershipResponseSchema = MembershipItemPermissionsSchema.extend({
  id: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  status: z.nativeEnum(MembershipStatusEnum),
  role: z.nativeEnum(MembershipRoleEnum),
  activationDate: z.string(),
  deactivationDate: z.string().nullable(),

  firstname: z.string(),
  lastname: z.string(),
  userId: z.string(),
  userEmail: z.string(),
  isConnectedToUser: z.boolean(),
  invitationStatus: InvitationStatusSchema,

  orgId: z.string(),
  orgName: z.string(),
})

export const HourReporterMemberSummarySchema = z.object({
  id: z.string(),
  firstname: z.string(),
  lastname: z.string(),
  userEmail: z.string(),
  role: z.nativeEnum(MembershipRoleEnum),
  status: z.nativeEnum(MembershipStatusEnum),
  invitationStatus: InvitationStatusSchema,
  orgId: z.string(),
})

export const HourReporterMembershipResponseSchema = HourReporterMemberSummarySchema.extend({
  checkers: z.array(HourReporterMemberSummarySchema),
  approvers: z.array(HourReporterMemberSummarySchema),
  reporterCountForCheck: z.number(),
  reporterCountForApproval: z.number(),
})

export const HourReportAuditableMembershipResponseSchema = z.object({
  id: z.string(),
  firstname: z.string(),
  lastname: z.string(),
  userEmail: z.string(),
  orgId: z.string(),
})

export const HourReportRoleAssignmentOptionSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.nativeEnum(MembershipRoleEnum),
  orgId: z.string(),
})

export const HourReportRoleAssignmentOptionsResponseSchema = z.object({
  options: z.array(HourReportRoleAssignmentOptionSchema),
})

export const HourReportAdminSchema = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  orgId: z.string(),
})

export const HourReportAdminsResponseSchema = z.object({
  canManageHourReportAdmins: z.boolean(),
  admins: z.array(HourReportAdminSchema),
})

export const HourReportAdminAssignmentOptionSchema = HourReportAdminSchema.extend({
  isHourReportAdmin: z.boolean(),
})

export const HourReportAdminAssignmentOptionsResponseSchema = z.object({
  options: z.array(HourReportAdminAssignmentOptionSchema),
})
